import { useEffect, useState } from "react";

let contentPromise = null;

const loadContent = () => {
  if (!contentPromise) {
    contentPromise = fetch(`${process.env.REACT_APP_BACKEND_URL}/api/content`)
      .then((r) => r.json())
      .catch(() => ({}));
  }
  return contentPromise;
};

export const refreshLogo = () => {
  contentPromise = null;
  window.dispatchEvent(new Event("logo-updated"));
};

// Current site logo — admin-uploaded (site content) or the bundled default.
export const useLogo = () => {
  const [logo, setLogo] = useState("/logo.png");
  useEffect(() => {
    let alive = true;
    const load = () =>
      loadContent().then((c) => {
        if (alive && c.logo_data) setLogo(c.logo_data);
      });
    load();
    window.addEventListener("logo-updated", load);
    return () => {
      alive = false;
      window.removeEventListener("logo-updated", load);
    };
  }, []);
  return logo;
};

export const Logo = ({ className = "", alt = "BEATKINGSMM" }) => {
  const src = useLogo();
  return <img src={src} alt={alt} className={className} />;
};
